import Marquee from "react-fast-marquee";

const WORDS = [
  "Digital Marketing",
  "Advertising",
  "Hospitality",
  "IT Consulting",
  "Online Growth",
];

export const EditorialMarquee = () => (
  <section className="py-16 md:py-24 border-y border-white/10 overflow-hidden" data-testid="marquee-section">
    <Marquee speed={45} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="marquee-item text-stroke text-6xl md:text-8xl lg:text-9xl px-8 font-light">
            {w}
          </span>
          <span className="text-quantum-gold text-4xl px-4">✦</span>
        </div>
      ))}
    </Marquee>
  </section>
);
